module.exports = __webpack_public_path__ + "img/facebook-logo-gray.0525b076.svg";